import RecordsPerPageSelector from './RecordsPerPageSelector';

export default RecordsPerPageSelector;